"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { motion, useScroll, useSpring, useReducedMotion } from "framer-motion";
import { Card, CardContent } from "@/shared/components/ui/card";
import { STEPS } from "../data/steps";
import { Reveal } from "./shared/reveal";
export const HowItWorks = () => {
  const $ = _c(13);
  const reduce = useReducedMotion();
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      target: ref,
      offset: ["start 70%", "end 60%"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    scrollYProgress
  } = useScroll(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      stiffness: 100,
      damping: 30
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const lineScale = useSpring(scrollYProgress, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="lg:sticky lg:top-28 lg:h-fit"><Reveal><span className="text-sm font-semibold uppercase tracking-widest text-zinc-500">How it works</span><h2 className="mt-3 text-balance text-3xl font-extrabold tracking-tight sm:text-4xl">Up and running in three steps</h2><p className="mt-4 text-pretty text-muted-foreground">Nothing to install. Sign up and your gym is live in minutes, with its own private login link.</p></Reveal></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute left-[1.30rem] top-2 bottom-2 w-0.5 rounded-full bg-border" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = reduce ? 1 : lineScale;
  let t5;
  if ($[4] !== t4) {
    t5 = <motion.div className="absolute left-[1.30rem] top-2 bottom-2 w-0.5 origin-top rounded-full bg-primary" style={{
      scaleY: t4
    }} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== reduce) {
    t6 = STEPS.map((step, i) => <motion.div key={step.title} className="relative" initial={reduce ? false : {
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: "-100px"
    }} transition={{
      duration: 0.5,
      ease: [0.21, 0.5, 0.3, 1]
    }}><span className="absolute -left-14 flex size-11 items-center justify-center rounded-full border border-primary/30 bg-background text-primary shadow-sm"><step.icon className="size-5" /><span className="absolute -right-1 -top-1 flex size-5 items-center justify-center rounded-full bg-primary text-[11px] font-bold text-primary-foreground">{i + 1}</span></span><Card className="shadow-md"><CardContent><h3 className="text-lg font-semibold">{step.title}</h3><p className="mt-2 text-sm text-muted-foreground">{step.description}</p></CardContent></Card></motion.div>);
    $[6] = reduce;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <div className="space-y-12">{t6}</div>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <section id="how-it-works" className="relative py-20 sm:py-28"><div className="mx-auto grid w-full max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-8">{t2}<div ref={ref} className="relative pl-14">{t3}{t5}{t7}</div></div></section>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};